export default __webpack_public_path__ + "static/media/CivilEng_Icon-02.fd5f6174.png";